require('../../modules/es6.date.now');
module.exports = require('../../modules/_core').Date.now;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/fn/date/now.js
// module id = 2302
// module chunks = 0